import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getCurrentDate } from '../../../helpers/Common';
import { REDUCER_NAME, downloadTopBreakout } from './reducer';
import ExportBlob from '../../../common/export-blob';
import Const from '../Const';

class ExportCommon extends React.Component {
  handleExport = () => {
    const {
      filter,
      timeRange,
      rate,
      downloadTopBreakout,
      typeTab,
    } = this.props;
    if (typeTab === 5) return;

    const apiParams = {
      ComGroupCode: filter,
      TimeRange: timeRange,
      Rate: rate,
      Screen: Const.screen[typeTab],
    };
    const name = `${I18n.t(`common.export.topMover.${typeTab}`, {
      date: getCurrentDate(),
      name: I18n.t('common.listComponent.TopBreakout'),
    })}`;
    downloadTopBreakout(apiParams, name);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => {
  return {
    timeRange: state[REDUCER_NAME].timeRange,
    rate: state[REDUCER_NAME].rate,
    i18n: state.i18n,
  };
};

const mapDispatchToProps = {
  downloadTopBreakout,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
